export { InfoBoxes } from './InfoBoxes'
export type { InfoBoxesProps } from './InfoBoxes'
